<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="copyright-page">
<div class="bxgrn">
<p class="cop_7"><span epub:type="pagebreak" id="page4" title="4">Copyright © 2015 by Kathy Patalsky</span></p>
<p class="cop">Interior photography © 2015 by Kathy Patalsky</p>
<p class="cop">All rights reserved.</p>
<p class="cop1">For information about permission to reproduce selections from this book, write to trade.permissions@hmhco.com or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.</p>
<p class="cop1"><a href="http://www.hmhco.com" target="_blank">www.hmhco.com</a></p>
<p class="cop1">Library of Congress Cataloging-in-Publication Data is available upon request. </p>
<p class="cop">ISBN 978-0-544-37980-0 (pbk.); 978-0-544-37696-0 (ebk.)</p>
<p class="cop1">Design by Amy Sly</p>
<p class="cop1">v1.0415</p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cop.vue?7fea0a20